export default __webpack_public_path__ + "static/media/logo-final.23d2d179.png";